/**
 * FireworkArtwork
 * Author: Wataru Fukushima
 * License: CC BY-ND 4.0
 */

import * as THREE from 'three'
import * as SimplexNoise from 'simplex-noise'

export default class FireworkFire {
  DURATION = 5000
  VELOCITY_THRESHOLD = 0.05
  GRAVITY_THRESHOLD = 0.3
  FRICTION = 0.988
  COUNT = 100
  duration = 5000
  fires = []
  vertices = []
  geometry = null
  material = null
  mesh = null
  eventBus = null
  isUpdating = false

  constructor({ artwork, x, y, z, count = this.COUNT }) {
    this.artwork = artwork
    this.artwork.eventBus.$on('onRender', this.render.bind(this))
    for (let i = 0; i < count; i++) {
      this.fires.push({
        angle: 15 * i + (10 * Math.random() - 5),
        // angle: 360 * Math.random(),
        velocity: 1.3 * Math.random() + 0.2, // degree
        gravity: 0.05,
        position: new THREE.Vector3(x, y, z)
      })
      this.vertices.push(new THREE.Vector3(x, y, z))
    }
    this.geometry = new THREE.Geometry()
    this.geometry.vertices = this.vertices
    const r = Math.floor(158 * Math.random() + 80)
    const g = Math.floor(158 * Math.random() + 50)
    const b = Math.floor(158 * Math.random() + 30)
    this.material = new THREE.PointsMaterial({
      size: 3,
      color: `rgb(${r}, ${g}, ${b})`,
      // color: 'rgb(239, 189, 129)',
      opacity: 1, // 0.5
      transparent: true
    })
    this.mesh = new THREE.Points(this.geometry, this.material)
  }

  decalerate(value) {
    return value > this.VELOCITY_THRESHOLD ? value * this.FRICTION : this.VELOCITY_THRESHOLD
  }

  gravitate(gravity) {
    return gravity > this.GRAVITY_THRESHOLD ? gravity * 1.0007 : this.GRAVITY_THRESHOLD
  }

  degreeToRadian(value) {
    return value * (Math.PI / 180)
  }

  debug(object) {
    console.log(JSON.parse(JSON.stringify(object)))
  }

  getNextPosition(position, angle, velocity, gravity) {
    const _position = position.clone()
    let nextPosition = new THREE.Vector3(
      _position.x + velocity * Math.cos(this.degreeToRadian(angle)),
      _position.y + velocity * Math.sin(this.degreeToRadian(angle)),
      _position.z
    )
    const gravitated = new THREE.Vector3(0, -gravity, 0)
    nextPosition = nextPosition.add(gravitated.clone())

    if (!this.simplex) this.simplex = new SimplexNoise()
    const noise = this.simplex.noise3D(position.x, position.y, position.z)
    const salted = new THREE.Vector3(noise * 0.05, -Math.abs(noise * 0.05), 0)
    return nextPosition.add(salted.clone())
  }

  update() {
    this.isUpdating = true

    const isFading = this.duration < this.DURATION / 2
    if (isFading) this.material.opacity -= 0.01

    this.fires.forEach((fire) => {
      fire.velocity = this.decalerate(fire.velocity)
      fire.gravity = this.gravitate(fire.gravity)
      const nextPosition = this.getNextPosition(fire.position, fire.angle, fire.velocity, fire.gravity)
      fire.position.copy(nextPosition)
    })

    const removing = this.duration <= 0
    if (removing) {
      this.fires = []
      this.vertices = []
      this.destroy()
    } else {
      this.vertices = this.fires.map((fire) => {
        return fire.position.clone()
      })
      this.mesh.geometry.vertices = this.vertices
      this.mesh.geometry.verticesNeedUpdate = true
    }
    this.isUpdating = false
  }

  render() {
    //* 火のアニメーション
    if (!this.mesh || this.isUpdating) return
    this.duration -= 1000 / 60
    this.update()
  }

  destroy() {
    this.artwork.scene.remove(this.mesh)
    this.geometry.dispose()
    this.material.dispose()
    this.artwork.eventBus.$emit('destroyInstance', this)
  }
}
